export default "__VITE_ASSET__BSr$EYU5__"